import React from 'react';
import styled, { css } from 'styled-components';

import { useTranslation } from '@components/I18nProvider';
import { generateNumberArray } from '@tager/web-core';

import { media } from '@/utils/mixin';
import { customPlaceholder } from '@/components/CustomPlaceholder/CustomPlceholder';

function PlaceholderForPost() {
  const { t } = useTranslation();
  return (
    <Component>
      <Header>
        <Left>
          <Image />
        </Left>

        <Right>
          <Title />
          <Excerpt />
          <Footer />
        </Right>
      </Header>

      <Section>
        {generateNumberArray(16).map((num) => (
          <Text key={num} />
        ))}
      </Section>

      <SectionOtherPost>
        <TitleOtherPost>{t('OtherArticles')}</TitleOtherPost>
        <PostList />
      </SectionOtherPost>
    </Component>
  );
}

const Component = styled.div``;
const Right = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 700px;
`;

const Header = styled.header`
  display: flex;
  flex-direction: row-reverse;
  ${media.tabletSmall(css`
    display: block;
  `)}
`;

const Footer = styled.div`
  margin-top: auto;
  display: flex;
  height: 17px;
  ${customPlaceholder}
`;

const Title = styled.div`
  height: 17px;
  margin-bottom: 10px;
  transition: none;
  ${customPlaceholder}
`;

const Excerpt = styled.div`
  height: 17px;
  margin-bottom: 15px;
  ${customPlaceholder}
`;

const Left = styled.div`
  width: 750px;
  min-width: 750px;
  overflow: hidden;
  position: relative;
  margin: 0 0 0 20px;
  img {
    width: 100%;
  }
  ${media.tabletLargeOnly(css`
    min-width: 500px;
    flex-basis: 500px;
    width: 500px;
  `)}
  ${media.tabletSmall(css`
    margin: auto;
    img {
      margin: auto;
    }
  `)}
  ${media.mobile(css`
    margin: 0 -16px 16px;
    width: auto;
    min-width: 0;
    display: block;
  `)}
`;
const Image = styled.div`
  width: 750px;
  min-width: 750px;
  height: 370px;
  ${customPlaceholder}
  ${media.tabletLargeOnly(css`
    min-width: 600px;
    height: 296px;
  `)}
   ${media.tabletSmallOnly(css`
    height: 138px;
  `)}
   ${media.mobile(css`
    margin: 0 auto;
    min-width: 414px;
    height: 222px;
  `)}
    ${media.mobileMedium(css`
    min-width: auto;
    margin: 0 auto;
    width: 100%;
    height: 222px;
  `)}
`;
const Section = styled.section`
  font-size: 18px;
  margin-top: 70px;
  padding-bottom: 40px;
  width: 700px;
  ${media.tabletSmall(css`
    margin-top: 20px;
    padding-bottom: 20px;
    width: auto;
  `)}
  ${media.mobile(css`
    padding-bottom: 0;
  `)}
`;
const Text = styled.div`
  height: 17px;
  margin-bottom: 10px;
  transition: none;
  ${customPlaceholder}
`;
const Content = styled.div``;
const SectionOtherPost = styled.section``;
const TitleOtherPost = styled.h2`
  display: block;
  margin-bottom: 25px;
  font-size: 32px;
`;
const PostList = styled.div`
  display: flex;
  margin-bottom: 35px;
  ${media.mobile(css`
    display: block;
  `)}
`;

export default PlaceholderForPost;
